import type { SelectedProfile } from '@/types/commercial/proposal-configurations';

interface StepConfigurationProfileTableProps {
  profiles: SelectedProfile[];
}

export function StepConfigurationProfileTable({ profiles }: StepConfigurationProfileTableProps) {
  if (profiles.length === 0) return null;

  return (
    <div className="mt-4 rounded-md border">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b bg-gray-50/50">
            <th className="px-4 py-2 text-left font-medium text-muted-foreground">Perfil</th>
            <th className="px-4 py-2 text-right font-medium text-muted-foreground">Quantidade</th>
          </tr>
        </thead>
        <tbody>
          {profiles.map((profile) => (
            <tr key={profile.id} className="border-b last:border-0">
              <td className="px-4 py-2">{profile.name}</td>
              <td className="px-4 py-2 text-right">{profile.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
